import client from './client'

const ADMIN_PREFIX = '/api/v1/admin'

export async function fetchAdminUsers() {
  const { data } = await client.get(`${ADMIN_PREFIX}/users`)
  return data
}

export async function blockAdminUser(id) {
  const { data } = await client.patch(`${ADMIN_PREFIX}/users/${id}/block`)
  return data
}

export async function unblockAdminUser(id) {
  const { data } = await client.patch(`${ADMIN_PREFIX}/users/${id}/unblock`)
  return data
}

export async function destroyAdminUser(id) {
  const { data } = await client.delete(`${ADMIN_PREFIX}/users/${id}`)
  return data
}

export async function destroyUserComments(id) {
  const { data } = await client.delete(`${ADMIN_PREFIX}/users/${id}/comments`)
  return data
}

export async function destroyUserCommentsAndBlock(id) {
  const { data } = await client.delete(`${ADMIN_PREFIX}/users/${id}/comments_and_block`)
  return data
}

export async function fetchAdminTracks() {
  const { data } = await client.get(`${ADMIN_PREFIX}/tracks`)
  return data
}

export async function archiveAdminTrack(id) {
  const { data } = await client.patch(`${ADMIN_PREFIX}/tracks/${id}/archive`)
  return data
}

export async function destroyAdminTrack(id) {
  const { data } = await client.delete(`${ADMIN_PREFIX}/tracks/${id}`)
  return data
}

export async function fetchAdminTrips() {
  const { data } = await client.get(`${ADMIN_PREFIX}/trips`)
  return data
}

export async function archiveAdminTrip(id) {
  const { data } = await client.patch(`${ADMIN_PREFIX}/trips/${id}/archive`)
  return data
}

export async function destroyAdminTrip(id) {
  const { data } = await client.delete(`${ADMIN_PREFIX}/trips/${id}`)
  return data
}

export async function fetchAdminComments({ type } = {}) {
  const params = type ? { type } : undefined
  const { data } = await client.get(`${ADMIN_PREFIX}/comments`, { params })
  return data
}

export async function hideAdminComment(commentType, id) {
  const { data } = await client.patch(`${ADMIN_PREFIX}/comments/${commentType}/${id}/hide_content`)
  return data
}

export async function destroyAdminComment(commentType, id) {
  const { data } = await client.delete(`${ADMIN_PREFIX}/comments/${commentType}/${id}`)
  return data
}

export async function fetchModerationActions({ kind, actor_id, target_type } = {}) {
  const params = {}
  if (kind) params.kind = kind
  if (actor_id) params.actor_id = actor_id
  if (target_type) params.target_type = target_type
  const { data } = await client.get(`${ADMIN_PREFIX}/moderation_actions`, { params })
  return data
}
